import Axios from "axios";

const instance = Axios.create();

export const API_URL = process.env.VUE_APP_RUTA_API;

console.log('ROOT_URL', API_URL);

const routes = {
  api_variable: "/api/variable/",
  api_posicion: "/api/posicion/",
  api_token: "/api/token/",
};


export const getVariables = () => {
  return instance.get(API_URL + routes.api_variable);
};
export const getPosiciones = (hearders) => {
  return instance.get(API_URL + routes.api_posicion,
    hearders);
};
export const postPosiciones = (data) => {
  return instance.post(API_URL + routes.api_posicion, data);
};
export const putPosiciones = (data) => {
  return instance.put(API_URL + routes.api_posicion + data.id + '/', data);
};
export const deletePosiciones = (data, accessToken) => {
  return instance.delete(API_URL + routes.api_posicion + data.id + '/', data,
    { headers: { Authorization: `Bearer ${accessToken}` } });
};
export const postLogin = (data) => {
  return instance.post(API_URL + routes.api_token, data);
};


export const getApi = (url) => {
  return instance.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
};

export const postApi = (data) => {
  return instance.post(data.url, data.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    }
  });
};


export const putApi = (data) => {
  return instance.put(data.url, data.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    }
  });
};

export const deleteApi = (data) => {
  return instance.delete(data.url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    }
  });
};
